import * as types from "../mutation-types";
function initialState() {
    return {
        includeReinvestment: false,
        reinvestCapitalGains: false,
        reinvestDividends: false
    };
}

const state = {
    ...initialState()
};

const getters = {
    reinvestmentSetting: state => {
        if (!state.includeReinvestment) {
            return undefined;
        }
        return {
            include: state.includeReinvestment,
            reinvestCapitalGains: state.reinvestCapitalGains,
            reinvestDividends: state.reinvestDividends
        };
    },
    getPreferenceReinvestmentSetting: (state, getters, rootState) => {
        return rootState.settings.preferences.reinvestSetting;
    }
};

const mutations = {
    [types.SET_REINVESTMENT_SETTING](state, data) {
        if (data) {
            state.includeReinvestment = data.include;
            state.reinvestCapitalGains = data.reinvestCapitalGains;
            state.reinvestDividends = data.reinvestDividends;
        } else {
            state.includeReinvestment = false;
        }
    },
    [types.SET_INCLUDE_REINVESTMENT](state, data) {
        state.includeReinvestment = data;
    },
    [types.SET_REINVEST_CAPITAL_GAINS](state, data) {
        state.reinvestCapitalGains = data;
    },
    [types.SET_REINVEST_DIVIDENDS](state, data) {
        state.reinvestDividends = data;
    },
    [types.RESET](state) {
        const initialData = initialState();
        Object.keys(initialData).forEach(key => {
            state[key] = initialData[key];
        });
    }
};

export default {
    state,
    mutations,
    getters
};
